const AIRCRAFT_NAMES = {
  '37S': null,
  '38A': 'Boeing 737',
  '38S': null,
  '3M8': 'Boeing 737-800',
  '3S8': null,
  '737': 'Boeing 737',
  '738': 'Boeing 737',
  '73H': 'Boeing 737',
  '772': null,
  '773': null,
  '777': null,
  '77E': null,
  '77L': null,
  '783': 'Dreamliner 787-8',
  '787': 'Dreamliner 787-8',
  '788': 'Dreamliner 787-8',
  '789': 'Dreamliner 787-9',
  '7M8': 'Boeing 737-800',
  '7M9': 'Boeing 737-900',
  '7S8': 'Boeing 737',
  '89S': 'Dreamliner 787-9',
  '8AS': null,
  'AT7': null,
  'E5S': null,
  'E70': null,
  'E75': null,
  'E7S': null,
  'E90': 'Embraer 190',
  'E92': null,
  'E95': 'Embraer 190',
  'E9A': 'Embraer 190',
  'E9S': null,
  'ER4': null,
  'ERJ': null,
  'JC2': null,
  'M7D': 'Embraer 190',
};

export default AIRCRAFT_NAMES;
